function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  className: "pos"
}, /*#__PURE__*/React.createElement("polygon", {
  points: "0,0 0,200 200,0  "
}), /*#__PURE__*/React.createElement("polygon", {
  points: "200,0 400,200 400,0  "
}), /*#__PURE__*/React.createElement("polygon", {
  points: "0,400 200,400 0,200  "
}), /*#__PURE__*/React.createElement("polygon", {
  points: "400,400 400,200 200,400  "
}));

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  className: "neg",
  x: 58.58,
  y: 58.58,
  transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -82.8427 200)",
  width: 282.84,
  height: 282.84
});

var SvgShapeFullRhomb = props => /*#__PURE__*/React.createElement("svg", _extends({
  x: "0px",
  y: "0px",
  width: "400px",
  height: "400px",
  viewBox: "0 0 400 400",
  style: {
    enableBackground: "new 0 0 400 400"
  },
  xmlSpace: "preserve"
}, props), _ref, _ref2);

export default __webpack_public_path__ + "static/media/shape-full_rhomb.d82843e5.svg";
export { SvgShapeFullRhomb as ReactComponent };